module.exports = __webpack_public_path__ + "img/jigsaw-back-5.edf3bf55.png";